import { render, staticRenderFns } from "./power.vue?vue&type=template&id=28fa9f1b&scoped=true"
import script from "./power.vue?vue&type=script&lang=ts"
export * from "./power.vue?vue&type=script&lang=ts"
import style0 from "./power.vue?vue&type=style&index=0&id=28fa9f1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fa9f1b",
  null
  
)

export default component.exports